export default __webpack_public_path__ + "static/media/rnr-sports-table-11.e7e3d5c2.webp";